import React from "react";
import { useFormContext } from "../../context/FormContext";
import { FormInput, FormRadioGroup } from "../shared/FormComponents";
import { YES_NO_OPTIONS } from "../../utils/constants";

const NABHDetails = () => {
  const { formData } = useFormContext();

  if (formData.nabh_accredited === "YES") {
    return (
      <FormInput
        id="nabhCertificateNo"
        name="nabhCertificateNo"
        label="NABH Accreditation Certificate No."
      />
    );
  }

  if (formData.nabh_accredited === "NO") {
    return (
      <FormRadioGroup
        name="nabhApplied"
        label="Whether applied for NABH"
        options={YES_NO_OPTIONS}
      />
    );
  }

  return null;
};

export default NABHDetails;
